module.exports = __webpack_public_path__ + "img/selected7-min.60d48236.png";